import Vue from 'vue'
import Vuex from 'vuex'
import userProfile from './modules/userProfile'
import businessProfile from './modules/businessProfile'
import businessPortalStats from './modules/businessPortalStats'
import telephoneCodes from './modules/telephoneCodes'
import countryList from './modules/countryList'
import urlPrefixes from './modules/urlPrefixes'
import cardholders from './modules/cardholders'
import sharedLinks from './modules/sharedLinks'
import linkInBio from './modules/linkInBio'
import transientLinkInBio from './modules/transientLinkInBio'
import currentEvent from './modules/currentEvent'
import currentPrize from './modules/currentPrize'
import snackbar from "./modules/snackbar"
import analyticData from './modules/analyticData'
import multiConnectEvents from './modules/multiConnectEvents'
import analytics from './modules/analytics';
import currentSubEvent from './modules/currentSubEvent';
import currentSession from './modules/currentSession';
import yourBusinessNetwork from './modules/yourBusinessNetwork'
import currentBusinessNetwork from './modules/currentBusinessNetwork'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    userProfile,
    businessProfile,
    businessPortalStats,
    telephoneCodes,
    sharedLinks,
    countryList,
    urlPrefixes,
    cardholders,
    linkInBio,
    snackbar,
    transientLinkInBio,
    currentEvent,
    currentPrize,
    snackbar,
    analyticData,
    multiConnectEvents,
    analytics,
    currentSubEvent,
    currentSession,
    yourBusinessNetwork,
    currentBusinessNetwork
  }
})
